module.exports = __webpack_public_path__ + "img/discover.b3d7853a.png";